import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//图标
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
//
import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont/iconfont.js";
//vxe-table
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

// 完整导入 UI 组件库
import VxeUI from 'vxe-pc-ui'
import 'vxe-pc-ui/lib/style.css'

import "@/assets/scss/vxe-table-theme.scss";

// 代码高亮
import hljs from 'highlight.js'
import 'highlight.js/styles/tokyo-night-dark.css'
// 重置浏览器默认样式
import "normalize.css";
// base公共样式
import "@/assets/scss/base.scss";
//ElementPlus自定义主题色
//https://blog.csdn.net/AK852369/article/details/127387167
import "@/assets/scss/element-theme.scss";

// 全局注册自定义指令
import directive from "@/directive/index";

// 富文本图片点击预览
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";

// createApp(App).use(store).use(router).mount("#app");

const app = createApp(App);

app.use(Viewer, {
  defaultOptions: {
    inline: false,  // 默认值：false。启用内联模式。
    button: true,  // 在查看器的右上角显示按钮。
    navbar: true,  // 指定导航栏的可见性。
    title: true,  // 指定标题的可见性和内容。
    toolbar: true,  // 指定工具栏及其按钮的可见性和布局。
    tooltip: true,  // 放大或缩小时显示带有图像比率（百分比）的工具提示。
    movable: true,  // 启用以移动图像。
    zoomable: true,  // 启用以缩放图像
    rotatable: true,  // 启用以旋转图像
    scalable: true,  // 启用以缩放图像。
    transition: true,  // 为某些特殊元素启用CSS3转换。
    fullscreen: true,  // 启用以在播放时请求全屏。
    keyboard: true,  // 启用键盘支持。
    // url: 'src',  //默认值：'src'。定义获取原始图像URL以供查看的位置。
  },
});

app.use(store).use(router).use(VxeUI).use(VXETable).use(directive).mount("#app");

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.directive('highlight', function (el) {
  let highlight = el.querySelectorAll('pre code');
  highlight.forEach((block) => {
    hljs.highlightBlock(block)
  })
});